var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bmui-field_arrow2" }, [
    _c("p", { staticClass: "bmui-field_arrow2-title" }, [
      _vm._v(_vm._s(_vm.title || "TITLE")),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNeed,
              expression: "isNeed"
            }
          ],
          staticClass: "bmui-field_arrow2-isNeed"
        },
        [_vm._v("*")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bmui-field_arrow2-wrap" }, [
      _c(
        "p",
        {
          staticClass: "bmui-field_arrow2-content",
          class: { "bmui-field_arrow2-empty": !_vm.content }
        },
        [_vm._v(_vm._s(_vm.content || _vm.placeholder || "请选择"))]
      ),
      _vm._v(" "),
      _c("i", { staticClass: "bmui-field_arrow2-icon" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8eb9da8", { render: render, staticRenderFns: staticRenderFns })
  }
}